/* eslint-disable @next/next/no-img-element */
import http from "utilities/http";
import PostBaiViet from "components/cong-dong/home-story";
import { isEmpty, has } from "lodash";
import { useEffect, useRef, useState } from "react";
import Paginate from "components/home/paginate";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import { numberWithDot } from "utilities/helper";
import Head from "next/head";
import SliderAd from "components/chuyen-gia/slider";

const countPostOverSlider = 6;
const perPage = 15;

export default function Index({ id, hashtag }) {
    const [state, _setState] = useState({
        contents: [],
        paginate: [perPage, 0],
    });
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    const fetchData = async (pageNumber) => {
        let url = `community/tag/${id}/posts?page=${pageNumber}&per_page=${perPage}`;
        const response = await http(url, {}, { token: 'Bearer ' + getCookie(TOKEN_CONGDONG) }, 'v2');

        setState({
            contents: response?.data || [],
            paginate: [perPage, response.meta?.pagination?.total || 0],
        });
    };
    useEffect(() => {
        fetchData(1);
    }, []);
    return (
        <>
            <Head>
                <title>Hashtag: #{hashtag} - Happynest</title>
                <meta property="og:title" content={'#' + hashtag} key="title" />
                <meta property="og:keywords" content={hashtag} key="keywords" />
            </Head>
            <section className="main main--photoStore">
                <div className="wrap anchor-link" id="danh-sach">
                    <h2 className="h2 mt-1">#{hashtag}</h2>
                    <p className="post mt-1"><span>{numberWithDot(state.paginate[1])}</span> bài đăng</p>
                    {!isEmpty(state.contents) &&
                        <>
                            <PostBaiViet item={state.contents.filter((f, k) => k < countPostOverSlider)} />
                            <SliderAd positionDesktop="2" pageDesktop="60" positionMobile="6" pageMobile="60" />
                            {state.contents.length > countPostOverSlider && <PostBaiViet item={state.contents.filter((f, k) => k >= countPostOverSlider)} />}
                        </>
                    }
                    {state.paginate[1] > state.paginate[0] && <Paginate paginate={state.paginate} fetchData={fetchData} scrollToEl="#danh-sach" />}
                </div>
            </section>
        </>
    );
};

export const getServerSideProps = async ({ params }) => {
    const response2 = await http(`community/tag/${params.id[0]}`, {}, {}, 'v2');
    if (response2.code == 200) {
        return {
            props: {
                id: params.id[0],
                hashtag: response2.data.slug,
            },
        };
    } else {
        return {
            props: {
                id: params.id[0],
                hashtag: params.id[1],
            },
        };
    }
};
